import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import axios from 'axios';

function UserProfile() {
  const { authTokens } = useContext(AuthContext);
  const [profileData, setProfileData] = useState({
    sex: '',
    age: '',
    weight: '',
    diets: [],
    medications: '',
    allergies: '',
    dislikedFoods: '',
    foodGoals: '',
  });

  useEffect(() => {
    axios
        .get('https://your-api-endpoint.com/user/preferences', {
          headers: { Authorization: `Bearer ${authTokens}` },
        })
        .then((response) => {
          console.log('Fetched user preferences:', response.data);
          setProfileData(response.data);
        })
        .catch((error) => {
          console.error('Error fetching user preferences:', error);
        });
  }, [authTokens]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfileData({ ...profileData, [name]: value });
    console.log(`Updated ${name}:`, value);
  };

  const handleMultiSelectChange = (e) => {
    const options = e.target.options;
    const selectedOptions = [];
    for (let i = 0, l = options.length; i < l; i++) {
      if (options[i].selected) {
        selectedOptions.push(options[i].value);
      }
    }
    setProfileData({ ...profileData, diets: selectedOptions });
    console.log('Updated diets:', selectedOptions);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Submitting profile data:', profileData);
    axios
        .post('https://your-api-endpoint.com/user/preferences', profileData, {
          headers: { Authorization: `Bearer ${authTokens}` },
        })
        .then((response) => {
          console.log('Preferences updated successfully:', response.data);
          alert('Preferences updated successfully');
        })
        .catch((error) => {
          console.error('Error updating preferences:', error);
          alert('Error updating preferences');
        });
  };

  return (
      <div className="container mt-5">
        <h2>My Profile</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Sex</label>
            <select
                className="form-control"
                name="sex"
                value={profileData.sex}
                onChange={handleChange}
                required
            >
              <option value="">Select</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              {/* Add more options as needed */}
            </select>
          </div>
          <div className="form-group">
            <label>Age</label>
            <input
                type="number"
                className="form-control"
                name="age"
                value={profileData.age}
                onChange={handleChange}
                required
            />
          </div>
          <div className="form-group">
            <label>Weight</label>
            <input
                type="number"
                className="form-control"
                name="weight"
                value={profileData.weight}
                onChange={handleChange}
                required
            />
          </div>
          <div className="form-group">
            <label>Diets</label>
            <select
                multiple
                className="form-control"
                name="diets"
                value={profileData.diets}
                onChange={handleMultiSelectChange}
            >
              <option value="Keto">Keto</option>
              <option value="Vegetarian">Vegetarian</option>
              <option value="Pescatarian">Pescatarian</option>
              {/* Add more options as needed */}
            </select>
          </div>
          <div className="form-group">
            <label>Medications</label>
            <input
                type="text"
                className="form-control"
                name="medications"
                value={profileData.medications}
                onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Allergies/Aversions</label>
            <input
                type="text"
                className="form-control"
                name="allergies"
                value={profileData.allergies}
                onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Disliked Foods</label>
            <input
                type="text"
                className="form-control"
                name="dislikedFoods"
                value={profileData.dislikedFoods}
                onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Food Goals</label>
            <input
                type="text"
                className="form-control"
                name="foodGoals"
                value={profileData.foodGoals}
                onChange={handleChange}
            />
          </div>
          <button type="submit" className="btn btn-primary">
            Update Preferences
          </button>
        </form>
      </div>
  );
}

export default UserProfile;
